export default __webpack_public_path__ + "static/media/vinca.ed0d29e6.jpeg";